'use client'

import { useIntersectionObserver } from 'hooks/useIntersectionObserver/useIntersectionObserver'
import { EmptyImage } from 'product-card/components/shared/ProductImage/EmptyImage/EmptyImage'
import { useEffect, useRef } from 'react'

type Props = {
	readonly isTwoColumnSize: boolean
	readonly onIntersect: () => void
}

export const EmptyProductCard = ({ isTwoColumnSize, onIntersect }: Props) => {
	const productCardRef = useRef<HTMLDivElement | null>(null)
	const productCardEntry = useIntersectionObserver(productCardRef, {
		threshold: [0, 1],
		rootMargin: '0px 0px 150px 0px',
		freezeOnceVisible: true,
	})

	useEffect(() => {
		if (productCardEntry?.isIntersecting) {
			onIntersect()
		}
	}, [productCardEntry?.isIntersecting, onIntersect])

	return <EmptyImage ref={productCardRef} isTwoColumnSize={isTwoColumnSize} />
}
